module.exports = __webpack_public_path__ + "assets/img/6c43ad83586bb20f4450a083b90c3ec0.png";